export default "__VITE_ASSET__CVQLEVuv__"